import {
  Building2,
  Footprints,
  Truck,
  SprayCan,
  Home,
  Building,
} from "lucide-react";

const SERVICES = [
  {
    icon: Building2,
    title: "Büroreinigung",
    text: "Zuverlässige Reinigung für gepflegte und hygienische Arbeitsräume.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/d213d7e40d21c51ac88922bd8c2e29f7f5144b557a2e38d9a9cf67f5c53b3607.png",
    alt: "Büroreinigung in Leonberg – Reinigungskraft reinigt einen Schreibtisch im Großraumbüro",
  },
  {
    icon: Footprints,
    title: "Treppenhausreinigung",
    text: "Saubere Eingangsbereiche und Treppenhäuser für einen positiven ersten Eindruck.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/a51a2c76ca667d46490fb1677e0da7e6896d267cf2f7f1c6407a052e82374aaa.png",
    alt: "Treppenhausreinigung in Leonberg – Reinigungskraft wischt die Treppenstufen, Geländer sichtbar",
  },
  {
    icon: Truck,
    title: "Umzugsreinigung",
    text: "Gründliche Reinigung vor oder nach dem Umzug.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/8d4b84ed35b7b621bc18b34b0c28f9ec43f1bc195967e76d8b13b014dad80f80.png",
    alt: "Umzugsreinigung in Leonberg – Reinigung einer leeren Wohnung mit Umzugskartons",
  },
  {
    icon: SprayCan,
    title: "Grundreinigung",
    text: "Intensive Reinigung für hartnäckige Verschmutzungen und schwer erreichbare Bereiche.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/519f6865ba9f2f3d1e4eb16356708bc748beae057d96c86bdfa89f969de24859.png",
    alt: "Grundreinigung in Leonberg – gründliches Schrubben stark verschmutzter Fliesenfugen",
  },
  {
    icon: Home,
    title: "Wohnungsreinigung",
    text: "Sorgfältige Reinigung von Wohnungen und Privathaushalten.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/10ac0a859d51b9b045862dcd27e8f92067832bb5582fbaa6e06f5ef53e25b267.png",
    alt: "Wohnungsreinigung in Leonberg – Reinigungskraft saugt das Wohnzimmer einer Wohnung",
  },
  {
    icon: Building,
    title: "Hausreinigung",
    text: "Flexible Reinigungslösungen für Häuser und größere Wohnbereiche.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/1f43e908c4ce1dc7476f1e6baf92bca3d4e78d1e103634ca8ea58764fd9be092.png",
    alt: "Hausreinigung in Leonberg – Reinigungskraft reinigt den großzügigen Wohnbereich eines Hauses",
  },
];

export const Services = () => {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#0077E6] mb-4">
            Leistungen
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A192F]">
            Unsere Leistungen
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group flex flex-col items-start overflow-hidden bg-white rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(10,25,47,0.04)] hover:-translate-y-2 hover:shadow-[0_20px_40px_rgb(10,25,47,0.09)] transition-all duration-300"
              >
                <div className="relative w-full h-44 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.alt}
                    width="1264"
                    height="848"
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute bottom-3 left-3 flex h-11 w-11 items-center justify-center rounded-xl bg-white/95 text-[#0077E6] shadow-sm backdrop-blur">
                    <Icon className="h-5 w-5" />
                  </div>
                </div>
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-[#0A192F]">
                    {s.title}
                  </h2>
                  <p className="mt-2 text-base text-slate-600 leading-relaxed">
                    {s.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
